import Component, { mixins } from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import PropertyCommons from '../commons/property.model';

@Component
export default class InputTextComponent extends mixins(PropertyCommons) {
  @Prop({ required: true })
  public value!: string;

  @Prop({ required: false, default: 'text' })
  public type: string;

  @Prop({ required: false })
  public max: string;

  get text(): string {
    return this.value;
  }

  set text(newValue: string) {
    this.$emit('input', newValue);
  }

  @Emit('change')
  onChange(e: Event) {
    return e;
  }

  @Emit('keypress')
  onKeypress(e: KeyboardEvent) {
    return e;
  }
}
